import { useNavigate } from 'react-router-dom';
import './BackButton.css';

export default function BackButton({ label = 'Voltar', to, className = '' }) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (typeof to === 'string' && to.length > 0) {
      navigate(to);
    } else {
      navigate(-1);
    }
  };

  return (
    <button
      type="button"
      className={`back-button ${className}`.trim()}
      onClick={handleClick}
    >
      <span aria-hidden="true">&lt;</span>
      <span className="back-button__label">{label}</span>
    </button>
  );
}
